// @core/api/endpoints/affiliate/update_commission_tier.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CommissionTierResponse,
  UpdateCommissionTierRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Update commission tier
 * Updates an existing commission tier with the provided data. Returns the updated resource.
 */
export async function UpdateCommissionTier(
  tier_id: string,
  data: UpdateCommissionTierRequest,
  options?: RequestOptions
): Promise<CommissionTierResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/commission-tiers/:tier_id`;
  requestPath = requestPath.replace(':tier_id', encodeURIComponent(tier_id));
  const requestOptions = options;
  return client.patch<CommissionTierResponse>(requestPath, data, requestOptions);
}
